import { render } from "./TextNr3.vue?vue&type=template&id=13dfd844&scoped=true"
import script from "./TextNr3.vue?vue&type=script&lang=js"
export * from "./TextNr3.vue?vue&type=script&lang=js"

import "./TextNr3.vue?vue&type=style&index=0&id=13dfd844&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dfd844"]])

export default __exports__